export const FRENCH_TRANSLATIONS = {
  text: {
    web_title: 'TABLEAU DE BORD SMARTZ™',
    authentication: 'Authentification',
    username: `Nom d'utilisateur`,
    password: 'Mot de passe',
    sign_in: 'Se connecter',
    username_required: `Nom d'utilisateur est requis`,
    password_required: 'Mot de passe est requis',
    invalid_credential: `Nom d'utilisateur ou mot de passe incorrect`,
    forgot_password: 'Mot de passe oublié',
    change: 'Changer',
    well_being: 'Bien-être',
    warnings: 'Mises en garde',
    no_patients_to_change: 'Aucun patient à changer',
    no_patients: 'Aucun patient',
    logout: 'Déconnexion',
    lost_connection: 'Connexion perdue avec le cloud Smartz™',
    check_connection: 'Veuillez vérifier votre connexion Internet',
    trying_to_reconnect: 'Tentative de reconnexion',
    pad_time: `Durée d'utilisation de la protection absorbante`,
    red_time: 'Durée en rouge',
    position: 'Position',
    time: 'Durée',
    time_in_position: 'Durée de présence en place',
    sitting: 'Assis',
    standing: 'Debout',
    left: 'Gauche',
    right: 'Droite',
    lying: 'Allongé',
    unknown: 'Inconnu',
    wet_surface: 'Surface humide',
    out_of_range: 'Hors de portée',
    low_battery: 'Batterie faible',
    disconnected: 'Déconnecté',
    unexpected_problem: 'Problème inattendu',
    ok: 'Ok',
    change_soon: 'Changer bientôt',
    change_pad: 'Changer la protection absorbante',
    languages: 'Langues',
    dashboard: 'TABLEAU DE BORD',
    pad_fill_profile: 'Profil de remplissage de la protection',
    goal: 'OBJECTIFS',
    report: 'RAPPORT',
    manage: 'GÉRER',
    individual: 'Individu',
    group: 'Groupe',
    action_required: 'ACTION REQUISE',
    monitor: 'SUIVRE',
    pod_unclipped: 'dispositif déclipsé',
    check_patient: 'vérifier le patient',
    check_pad: 'vérifier la protection absorbante',
    check_time_in_pad: `vérifier la durée d'utilisation de la protection absorbante`,
    check_position: 'vérifier la position',
    check_temperture: 'vérifier la température',
    check_pad_fill_profile:
      'VÉRIFIER LE PROFIL DE REMPLISSAGE DE LA PROTECTION',
    instructions: 'instructions',
    time_in_pos: 'durée dans la position',
    pad_capacity: 'capacité de la protection',
    time_in_pad: `durée d'utilisation de la protection`,
    ambient: 'ambiant',
    time_at_temp: 'temps à température',
    pad_wet: 'PROTECTION HUMIDE',
    pad_dry: 'PROTECTION SÈCHE',
    daily_pad_fill: 'Remplissage quotidien de la protection',
    seven_day_trend: 'Tendance sur sept jours',
    daytime: 'Journée',
    nighttime: 'Nuit',
    volume_in_pad: 'Volume absorbé dans la protection',
    pad_fill_summary: 'RÉSUMÉ DU REMPLISSAGE DE LA PROTECTION',
    daily_average: 'Moyenne journalière',
    today: `Aujourd'hui`,
    capacity: 'Capacité',
    pads_used: 'protections utilisées',
    per_day: 'par jour',
    average: 'moyenne',
    leakage_detected: 'Fuite détectée',
    times: 'durées',
    pad_cycles: 'Cycles de protection',
    time_in_a_pos: 'Durée dans une pos',
    max_time_in_a_pos: 'Durée maximum en position',
    re_positioning: 'Repositionnement',
    time_day: 'fois/jour',
    temperature: 'Température',
    typical_temp: 'Température typique',
    temp_range: 'Gamme de température',
    charts: 'GRAPHIQUES',
    pad_fill_profile_for_7_days:
      'Profil de remplissage de protection : tendance sur sept jours',
    daily_total: 'Total journalier',
    accuracy: 'précision',
    last_24_hours: '24 heures à partir de la date sélectionnée',
    volume_voided_in_pad: 'volume des mictions absorbées dans la protection',
    body: 'Corps',
    wetness_usage: 'humidité/utilisation',
    environment_body: 'température ambiante',
    activity: 'Activé',
    lift_style: 'style de levage',
    skin_care: 'Soins de la peau',
    skin_care_management: 'gestion des soins de la peau',
    workflow: 'Flux de travail',
    workflow_efficiency: 'efficacité des flux de travail',
    set_maximum_voiding_volume_into_pad:
      'Définir le maximum de volume des mictions absorbées dans la protection',
    less_void: 'MOINS DE MICTION',
    more_void: 'PLUS DE MICTION',
    day: 'JOUR',
    night: 'NUIT',
    day_time: 'La journée',
    night_time: 'La nuit',
    average_period: 'Période moyenne',
    default: 'PAR DÉFAUT',
    desire_position: 'Durée passée dans position',
    time_in_a_position: 'Durée passée dans une position',
    desire_temperature: 'Température environnante du dispositif',
    coloer: 'PLUS FROID',
    hotter: 'PLUS CHAUD',
    desire_skin_care: 'Soins de la peau',
    off: 'OFF',
    standard_care: 'SOINS STANDARD',
    extra_care: 'SOINS SUPPLÉMENTAIRES',
    more_time_in_wet_pad: 'PLUS DE TEMPS DANS LA PROTECTION HUMIDE',
    more_time_in_a_pos: 'PLUS DE TEMPS DANS UNE POS',
    less_time_in_wet_pad: 'MOINS DE TEMPS DANS LA PROTECTION HUMIDE',
    less_time_in_a_pos: 'MOINS DE TEMPS DANS UNE POS',
    override:
      'Cet objectif prévaudra sur les objectifs de la protection et du corps',
    check_pod: 'vérifier le dispositif',
    check_pod_and_reclip: 'vérifier le dispositif et reclipser',
    lost_connect: 'Connexion perdue',
    voids_into_pad_hours:
      'Mictions dans la protection au cours des 96 dernières heures',
    chart_date: 'Date du graphique',
    fullscreen: 'Plein écran',
    normalscreen: 'Écran normal',
    void_chart: 'Graphique représentant les mictions',
    voids_into_pad: 'mictions dans la protection',
    pad_fill_trend: 'profil de remplissage de protection',
    legend: 'LÉGENDE',
    new_pad: 'nouvelle protection',
    void_in_pad: 'miction dans la protection',
    share: 'Partager',
    print: 'Imprimer',
    position_profile: 'Profil de la position',
    body_position: 'Position du corps',
    body_positions_over_96_hours: 'Positions du corps sur 96 heures',
    lying_on_back: 'Allongé, sur le dos',
    lying_on_front: 'Allongé, sur le ventre',
    lying_left_side: 'Allongé, sur le côté gauche',
    lying_right_side: 'Allongé, sur le côté droit',
    standing_walking: 'Debout/En marchant',
    stats: 'statistiques',
    pad_used: 'protection_utilisée',
    max: 'max',
    surrounding_temperature: 'TEMPÉRATURE AMBIANTE',
    temp: 'température',
    avg: 'moyenne',
    name: 'Nom',
    provider: 'Fournisseur',
    purpose: 'Objectif',
    expiry: 'Expiration',
    type: 'Type',
    frequently_asked_questions: 'Foire Aux Questions',
    information_for_use: 'Informations d’emploi',
    data_privacy: 'Confidentialité des données',
    eula: 'CLUF',
    about: 'À propos',
    settings: 'Paramètres',
    save: 'Enregistrer',
    version: 'version',
    support: 'assistance',
    close: 'Fermer',
    copyright:
      'Copyright (C) 2022 Smartz Operations Limited. Tous droits réservés',
    smartz_devices: 'Appareils Smartz™',
    monitor_smartz_device_operation: `surveiller le fonctionnement de l'appareil Smartz™`,
    last_seen: 'Vu pour la dernière fois',
    battery: 'Batterie',
    ago: 'il y a',
    date_rate: 'Débit de données',
    online: 'En ligne',
    singnal: 'Signal',
    temperature_goal: 'OBJECTIF DE TEMPÉRATURE',
    data_privacy_desc: 'gérer le consentement et les données personnelles',
    organisation: 'ORGANISATION',
    organisation_desc: 'gérer les paramètres du groupe',
    my_account: 'Mon compte',
    my_account_desc: 'gérer les paramètres du compte',
    consent: 'Consentement',
    marketing_comm: 'Marketing, communications et promotions',
    consent_desc: `Les fabricants et distributeurs de protections peuvent utiliser les données personnelles à des fins de marketing et de promotion. Le compte de l'utilisateur (ou des utilisateurs), le cas échéant, associé à ce patient peut être envoyé par e-mail périodiquement. Dans ce cas, l'e-mail de l'utilisateur peut être partagé avec des tiers.`,
    data_management: 'Gestion des données',
    Permanently_delete_account:
      'Supprimer définitivement ce compte utilisateur',
    permanently_delete_client: 'Supprimer définitivement ce client',
    data_management_desc:
      'Le compte ne sera plus disponible, et toutes les données du compte seront définitivement supprimées.',
    how_can_i_export:
      'Comment puis-je exporter et sauvegarder les données de mon compte ?',
    save_preference: 'SAUVEGARDER LES PRÉFÉRENCES',
    delete_account_data: 'SUPPRIMER LE COMPTE ET LES DONNÉES',
    date_time_settings: `Paramètres de date et d'heure`,
    morning_time: 'Matin',
    night_time_label: 'Nuit',
    time_format: `Format de l'heure`,
    date_format: 'Format de date',
    goal_text: 'objectif',
    day_goal: 'objectif du jour',
    night_goal: 'objectif de la nuit',
    check_battery: 'VÉRIFIER LA BATTERIE',
    reminders: 'rappels',
    update_data_privacy_consent:
      'Mettre à jour le consentement de confidentialité des données',
    update: 'Mettre à jour',
    user: 'Utilisateur',
    last_updated: 'Dernière mise à jour',
    action: 'Action',
    delete_confirm: 'Êtes-vous sûr de vouloir le supprimer ?',
    cancel: 'Annuler',
    lost_internet_connection: 'CONNEXION INTERNET PERDUE',
    check_setting:
      'Veuillez vérifier vos paramètres Internet et vos connexions',
    authentication_required: 'Authentification obligatoire',
    account_details_have_changed: 'Les détails du compte ont changé',
    date: 'Date',
    no_pod_assigned: 'aucun dispositif attribué',
    monitoring_is_not: `La surveillance n'est pas disponible car un dispositif Smartz™ n'a pas été attribué à `,
    assign_a_pod: 'Attribuer un dispositif à',
    on_the_smartz_monitor_app: `dans l'application Smartz™ Monitoring pour activer la surveillance.`,
    see: 'Voir',
    delete: 'supprimer',
    keep_in_mind_delete_data: `Veuillez garder à l'esprit que la suppression du compte utilisateur et des données personnelles est permanente.`,
    you_able_to_delete_data: 'Vous êtes sur le point de supprimer',
    account_and_data: 'compte et données',
    this: 'ici',
    average_time_in_pad: 'Durée moyenne dans la protection',
    average_time_in_position: 'Durée moyenne en position',
    repositioning_24h: 'Repositionnement 24 h',
    last_7_day_period: 'Période des 7 derniers jours',
    admin: 'ADMIN',
    administraive_settings: `paramètres d'administration`,
    group_data_rentenion: 'Location de données de groupe',
    maximum_inactivity_data_retention_period: `Période de conservation maximale des données d'inactivité`,
    group_data_rentenion_desc: `Les données personnelles de tous les utilisateurs et patients de ce groupe seront supprimées si la période d'inactivité a été atteinte.`,
    data_rentenion_detail: `Les conditions d'inactivité sont les suivantes :<br>- Le dispositif n'est pas attribué au patient pendant une période donnée<br>- Le dispositif est attribué au patient mais ne transmet pas de données aux applications Smartz™ pendant une période donnée<br>- L'utilisateur ne s'est pas connecté pendant une période donnée`,
    months: 'mois',
    user_roles: 'Rôles des utilisateurs',
    users: 'Utilisateurs',
    role: 'Rôle',
    filter_by_group_or_users: 'filtrer par groupe ou utilisateurs',
    urine_conversion_feature: 'Fonction de conversion des urines',
    use_urine_transform: 'Utiliser Urine Transform',
    system_data_rentenion: 'Location de données système',
    system_data_rentenion_desc: `Les données personnelles de tous les utilisateurs et patients de ce système seront supprimées si la période d'inactivité a été atteinte.`,
    reset_password: 'Réinitialiser le mot de passe',
    new_password: 'Nouveau mot de passe',
    confirm_password: 'Confirmer le mot de passe',
    password_inconsistent: 'Le mot de passe ne correspond pas',
    edit: 'modifier',
    edit_roles: 'Modifier les rôles',
    available_roles: 'Rôles disponibles',
    assigned_roles: 'Rôles attribués',
    role_list: 'Liste des rôles',
    role_name: 'Nom du rôle',
    role_permissions: 'Permissions associées à un rôle',
    level_1_module: 'Module de niveau 1',
    level_2_module: 'Module de niveau 2',
    permissions: 'Permissions',
    add_role: 'AJOUTER UN RÔLE',
    roles: 'rôles',
    role_settings: 'paramètres des rôles',
    edit_role: 'Modifier le rôle',
    account_take_effect: 'La mise à jour prendra effet après la reconnexion.',
    algorithms: 'Algorithmes',
    delete_role_confirm: 'La suppression du rôle est permanente.',
    //translate permissions list
    'Dashboard Module': 'Module de tableau de bord',
    'Charts Module': 'Module Graphiques',
    'Goals Module': 'Module Objectifs',
    'Manage Module': 'Gérer le module',
    Group: 'Groupe',
    Individual: 'Individu',
    'Voiding Chart': 'Graphique représentant les mictions',
    'Pad Fill Profile Chart':
      'Graphique de profil de remplissage de la protection',
    'Body Position Chart': 'Graphique de position du corps',
    'Smartz Devices Chart': 'Graphique des appareils Smartz™',
    'Pad Fill Profile': 'Profil de remplissage de la protection',
    'Skin Care': 'Soins de la peau',
    Position: 'Position',
    Temperature: 'Température',
    Admin: 'Administrateur',
    'My Account': 'Mon compte',
    Role: 'Rôle',
    Organisation: 'Organisation',
    'Data Privacy': 'Confidentialité des données',
    View: 'Lire',
    Share: 'Partager',
    Print: 'Imprimer',
    Save: 'Enregistrer',
    'Reset Password': 'Réinitialiser le mot de passe',
    Delete: 'Supprimer',
    Add: 'Ajouter',
    Edit: 'Modifier',
    Fall: 'Chute',
    //end translate permissions list
    check_fall: 'VÉRIFIER LA CHUTE',
    position_goal_not_allow_off:
      "L'objectif de position ne peut pas être désactivé alors que l'objectif de chute est activé pour améliorer la sécurité.",
    falls: 'Chutes',
    falls_detection_and_notification: 'détection et notification des chutes',
    falls_detection: 'Détection des chutes',
    detect_falls: 'Détecter les chutes',
    on: 'ON',
    position_goal: 'Objectif de position',
    has_been_turn_on:
      'a été activé pour compléter la détection des chutes et améliorer la sécurité.',
    last_fall: 'Dernière chute',
    last_week: 'semaine dernière',
    three_months: '3 mois',
    time_to_change: `L'heure du changement`,
    sent_successfully: 'Envoyé avec succès',
    sent_failed: `Échec de l'envoi`,
    send_email: 'Envoyer un e-mail',
    send: 'Envoyer',
    add_email: 'Ajouter un e-mail',
    saved_successfully: 'Sauvegardé avec succès',
    saved_failed: 'Sauvegarde échouée',
    deleted_successfully: 'Supprimé avec succès',
    deleted_failed: 'Échec de la suppression',
    email: 'E-mail',
    please_enter_email_address: 'Veuillez saisir votre adresse e-mail',
    please_enter_the_correct_email_address: `Veuillez saisir l'adresse e-mail correcte`,
    time_in_a_pad_goal: `OBJECTIF DE DURÉE D'UTILISATION D'UNE PROTECTION `,
    time_goal: 'OBJECTIF DE DURÉE',
    body_temperature: 'Température du corps',
    upper_goal_limit: `limite supérieure d'objectif`,
    lower_goal_limit: `limite inférieure d'objectif`,
    time_of_fall: 'heure de chute',
    heart_rate: 'Fréquence cardiaque',
    max_heart_rate: 'Fréquence cardiaque max',
    min_heart_rate: 'Fréquence cardiaque min',
    average_heart_rate: 'Fréquence cardiaque moyenne',
    oximetry: 'Oxymétrie',
    blood_o2_saturation: 'saturation du sang en oxygène',
    min_oximetry: 'Oxymétrie min',
    max_oximetry: 'Oxymétrie max',
    average_oximetry: 'Oxymétrie moyenne',
    respiration: 'Respiration',
    breathing_pattern: 'modèle respiratoire',
    breath: 'respiration',
    respiration_vs_oximetry: 'Respiration vs oxymétrie',
    min_respiration: 'Respiration min',
    max_respiration: 'Respiration max',
    average_respiration: 'Respiration moyenne',
    balance: 'Solde',
    falls_and_balance: 'chutes et équilibre',
    loss_of_balance_events: `Événements de perte d'équilibre`,
    sudden_changes_in_body_orientation: `Changements soudains de l'orientation du corps`,
    goal_limit: `limite d'objectif`,
    last_event_exceeding_goal: `Dernier événement dépassant l'objectif`,
    balance_loss_events: `Événements de perte d'équilibre`,
    per_7_days: 'par 7 jours',
    body_lean_over_7_days: 'Maigreur du corps sur 7 jours',
    chart_shows_tendency:
      'Le graphique montre la tendance du corps à se pencher dans une direction particulière tout en se déplaçant',
    lean_forward: 'Pencher en avant',
    backwards: 'en arrière',
    forward: 'en avant',
    vitals: 'VITALES',
    vitals_signs: 'FONCTIONS VITALES',
    spo2: 'SPO2',
    pulse: 'Pouls',
    abdominal_movement: 'Mouvement abdominal',
    min: 'min',
    attach_the_pod:
      'Ne fixez le dispositif que lorsque la protection est déjà sur le patient. Le non-respect de cette consigne peut entraîner une détection erronée d’une chute en raison du mouvement et de la manipulation de la protection avant son application sur le patient.',
    body_positions_analysis: 'Analyse des positions du corps',
    repositioning: 'Repositionnement',
    stayed_in_one_position: 'est resté dans une position',
    change_in_position: 'changement de position',
    no_pod_data: 'pas de données sur le dispositif',
    possible_intervention: 'Intervention possible',
    body_position_goal: 'OBJECTIF DE POSITION DU CORPS',
    tap_to_setup_body_position_goals:
      'appuyez pour définir les objectifs de position du corps',
    time_blocks_greater_than: 'blocs de temps supérieurs à',
    will_be_highlighted: 'sera surligné',
    chart_filters: 'FILTRES GRAPHIQUES',
    tap_to_show: 'appuyez pour afficher',
    tap_to_hide: 'appuyez pour masquer',
    notifications: 'Notifications',
    time_to_reposition: 'Délai-de-repositionnement',
    hour: 'heure',
    hours: 'heures',
    minute: 'minutes',
    minutes: 'minutes',
    sensor_disconnected: 'capteur déconnecté',
    from: 'DE',
    to: 'À',
    quick_start_guide: 'Guide de démarrage rapide',
    wet_outside: 'Humidité en dehors de la protection',
    attend_fall: `S'OCCUPER D'UNE CHUTE`,
    reclip_pod: 'RECLIPSER LE DISPOSITIF',
    change_position: 'CHANGER LA POSITION',
    replace_battery: 'REMPLACER LA BATTERIE',
    allowed_time_exceeded: 'Délai autorisé dépassé',
    wetness_outside: `Humidité à l'extérieur`,
    analysing_pad: 'Analyse de la protection',
    pad_not_selected: 'Protection non sélectionnée',
    silence: 'Mettre en sourdine',
    silence_confirm_box_title: 'Mettre en sourdine les chutes',
    silence_confirm_box_content:
      'Mettre en sourdine les notifications de chutes les supprimera du tableau de bord de groupe. Voulez-vous continuer ? ',
    yes: 'OUI',
    no: 'NON',
    pad_status: 'ÉTAT DE LA PROTECTION',
    check_pad_fill: 'VÉRIFIER LE REMPLISSAGE DE LA PROTECTION',
    patient_profile: 'PROFIL DU PATIENT',
    periods: 'Périodes',
    products: 'Produits',
    active: 'actif',
    manage_user_profile: 'Gérer le profil utilisateur',
    sign_out: 'Se déconnecter',
    view: 'Lire',
    groups: 'groupes',
    groups_in_view: 'Groupes dans une vue',
    total_daily_profile: 'Profil quotidien total',
    day_profile: 'Profil journalier',
    night_profile: 'Profil de nuit',
    pad_fill_profile_goal: 'OBJECTIF DU PROFIL DE REMPLISSAGE DE LA PROTECTION',
    tap_to_setup_pad_fill_profile_goals:
      'appuyez pour configurer des objectifs de profil de remplissage de la protection',
    insufficient_data: 'Données insuffisantes',
    last_7_days: 'Les 7 derniers jours',
    pad_removed: 'protection retirée',
    view_groups: 'Voir le(s) groupe(s)',
    minimum_voiding_into_pad:
      'Minimum de mictions absorbées dans la protection',
    Monday: 'Lundi',
    Tuesday: 'Mardi',
    Wednesday: 'Mercredi',
    Thursday: 'Jeudi',
    Friday: 'Vendredi',
    Saturday: 'Samedi',
    Sunday: 'Dimanche',
    disconnected_desc:
      'en attente de reclippage du dispositif sur la protection...',
    pod_unclipped_desc: 'en attente que le dispositif revienne à portée...',
    password_policy: 'Politique de mot de passe',
    position_chart: 'Graphique de position',
    hi_everyone: 'Bonjour à tous',
    voiding_chart_email_content:
      'Le graphique des mictions envoyé par e-mail est prêt à être examiné.',
    pad_fill_profile_chart_email_content:
      'Le graphique de profil de remplissage de la protection envoyé par e-mail est prêt à être examiné.',
    position_chart_email_content:
      'Le graphique des positions envoyé par e-mail est prêt à être examiné.',
    temperature_chart_email_content:
      'Le graphique des températures envoyé par e-mail est prêt à être examiné.',
    heare_rate_chart_email_content:
      'Le graphique de la fréquence cardiaque envoyé par e-mail est prêt à être examiné.',
    oximtry_chart_email_content: `Le graphique d'oxymétrie envoyé par e-mail est prêt à être examiné.`,
    respiration_chart_email_content:
      'Le graphique de respiration envoyé par e-mail est prêt à être examiné.',
    balance_chart_email_content: `Le graphique d'équilibre envoyé par e-mail est prêt à être examiné.`,
    smartz_chart_email_content:
      'Le graphique Smartz™ envoyé par e-mail est prêt à être examiné.',
    best_regards: 'Cordialement,',
    the_simavita_team: `L'équipe d'exploitation Smartz`,
    days: 'jours',
    weeks: 'semaines',
    years: 'années',
    reset_all_users_passwords:
      'Réinitialiser tous les mots de passe des utilisateurs',
    reset_all_passwords: 'Réinitialiser tous les mots de passe',
    reset: 'Réinitialiser',
    change_password: 'Modifier le mot de passe',
    old_password: 'Ancien mot de passe',
    lowercase: 'Minuscule',
    uppdercase: 'Majuscule',
    number: 'Numéro',
    please_select: 'Veuillez sélectionner',
    loading_chart: 'Graphique de chargement',
    please_wait: 'Patientez s’il vous plait...',
    edit_user: `Modifier l'utilisateur`,
    add_user: 'Ajouter un utilisateur',
    edit_group: 'Modifier le groupe',
    add_group: 'Ajouter un groupe',
    group_name: 'Nom du groupe',
    group_name_required: 'Nom du groupe est requis',
    patients: 'Patients',
    manage_user_account: `gérer le compte de l'utilisateur`,
    filter_by_group_name: 'filtrer par nom de groupe',
    delete_group_warning: `Veuillez garder à l'esprit que la suppression d'un groupe est permanente.`,
    delete_patient_warning:
      'La suppression des données du patient et des données personnelles est permanente.',
    pod_mac: 'Dispositif Mac',
    pod_serial_number: 'Numéro de série du dispositif',
    add_patient: 'Ajouter un patient',
    edit_patient: 'Modifier le patient',
    alias: 'Alias',
    alias_required: 'Alias est requis',
    pod_mac_required: 'Le dispositif Mac est requis',
    pod_serial_number_required: 'Le numéro de série du dispositif est requis',
    please_enter_capital_letters_and_numbers:
      'Veuillez saisir uniquement des lettres majuscules et des chiffres',
    select_date_range: 'Sélectionner la fourchette de dates',
    start_time: 'heure de début',
    end_time: 'heure de fin',
    select_groups_to_collate: 'Sélectionner le(s) groupe(s) à rassembler',
    all_groups: 'Tous les groupes',
    export_report: 'Exporter le rapport',
    export_csv: 'Exporter CSV',
    reports: 'Rapports',
    please_complete_form: 'Veuillez remplir le formulaire',
    nodes: 'Nœuds',
    network_map: 'Plan de réseau',
    network_utilisation: 'Utilisation du réseau',
    notify_me_when_nodes_offline: `M'avertir lorsque le(s) nœud(s) est(sont) hors ligne`,
    zoom_in_chart: 'Activer le zoom dans le graphique',
    latency: 'Latence',
    lan: 'LAN',
    wifi_infrastructure: 'Infrastructure Wi-Fi',
    pods: 'Dispositifs',
    data: 'Données',
    packet_less: 'Paquet moins',
    secondary_connection: 'Connexion secondaire',
    rssi: 'RSSI',
    no_nodes: 'Pas de nœuds',
    share_code: 'Code de partage',
    //Start translation from here.
    active_patients: 'Patients en cours',
    archived_patients: 'Patients archivés',
    archive: 'archives',
    restore: 'restaurer',
    are_you_sure: 'Êtes-vous sûr ?',
    you_about_to_archive: `Vous êtes sur le point d'archiver`,
    default_group_not_delete: 'Le groupe par défaut ne peut pas être supprimé',
    patients_belong_to: 'Patients appartenant à',
    move: 'Mouvement',
    warning: 'Avertissement',
    add_node: 'Ajouter un nœud',
    edit_node: 'Modifier un nœud',
    room_name: 'N° chambre',
    mac_address: 'Adresse MAC',
    delete_node_warning: `La suppression d'un nœud est permanente. `,
    mac_address_required: `L'adresse Mac est requise`,
    room_name_required: 'Le nom de la chambre est requis',
    mac_address_format_warning: `Le format d'adresse MAC saisi est incorrect. Veuillez le saisir sous la forme XX:XX:XX:XX:XX:XX`,
    node_management: 'Gestion des nœuds',
    time_period: 'Période de temps',
    manufacturer: 'Fabricant',
    product: 'Produit',
    please_select_time_period: 'Veuillez sélectionner une période',
    please_select_manufacturer: 'Veuillez sélectionner le fabricant',
    please_select_product: 'Veuillez sélectionner un produit',
    no_data: 'Aucune donnée',
    please_select_manufacturer_first: `Veuillez d'abord sélectionner le fabricant`,
    details: 'Détails',
    time_period_warning:
      'La période de jour et la période de nuit doivent couvrir la durée totale de la journée pendant 24 heures.',
    reset_successfully: 'Réinitialisation réussie',
    region: 'Région',
    select_at_least_one_group: 'Selectionnez au moins un groupe',
    node: 'Nœud',
    pods_location: 'Emplacement des dispositifs',
    pod_id: 'ID du dispositif',
    accelerometer: 'Accéléromètre',
    senser: 'Capteur',
    gain: 'Gain',
    offset: 'Compensation',
    failed_to_connecte_smartz_service:
      'Échec de la connexion au service Smartz<sup>®</sup>',
    add_to_smartz_group_failed: `Échec de l'ajout au service du groupe smartz`,
    retry: 'Réessayer',
    customization: 'Personnalisation',
    customization_settings: 'Paramètres de personnalisation',
    colors: 'Couleurs',
    font: 'Police',
    logo: 'Logo',
    login_background: `Fond d'écran pour la connexion`,
    apply: 'Les',
    theme: 'appliquer',
    to_current_site: 'au site actuel',
    customize_theme_text: `Personnaliser l'apparence du site. Vous vous sentez d’humeur aventureuse ?`,
    create_a_custom_theme: 'Créer un thème personnalisé',
    custom_theme: 'Thème personnalisé',
    preview: 'aperçu',
    reset_customization_settings:
      'Toutes les configurations ont été restaurées par défaut',
    drag_the_logo_here: 'Faites glisser le logo ici',
    or: 'ou',
    click_upload: 'cliquez sur télécharger',
    only_image_files_can_be_uploaded:
      'Seuls les fichiers JPG / PNG peuvent être téléchargés',
    the_size_of_the_uploaded_image_cannot_exceed: `La taille de l'image téléchargée ne peut pas dépasser 2 Mo`,
    please_sign_out_to_preveiw_effect: `Après le téléchargement, veuillez vous déconnecter pour prévisualiser l'effet`,
    please_enter_theme_name: 'Veuillez saisir le nom du thème',
    failed: 'Échec',
    add_pod: 'Ajouter un dispositif',
    edit_pod: 'Modifier un dispositif',
    filter_pod: 'Filtrer par adresse mac de dispositif',
    filter_node: 'Filtrer par nœud, adresse MAC et chambre',
    delete_pod_warning: `La suppression d'un nœud est permanente. `,
    delete_theme_warning: 'La suppression du thème sera permanente.',
    apply_theme_warning:
      'Remarque : cette opération appliquera les paramètres personnalisés au nom de domaine. Faites attention.',
    please_enter_domain_name: 'Veuillez saisir un nom de domaine',
    domain_name_incorrect: 'Le format du nom de domaine est incorrect',
    apply_successfully: 'Appliqué avec succès',
    location: 'Lieu',
    manufacturer_code: 'Code du fabricant',
    node_mac_address: 'Adresse Mac du nœud',
    expired: 'Expiré',
    please_select_location: 'Veuillez sélectionner le lieu',
    filter_patients: 'Filtrer les patients',
    monitor_patient: 'Surveiller le patient',
    patient: 'Patient',
    room: 'Chambre',
    assign: 'Attribuer',
    unassign: 'Retirer l’attribution',
    unassign_patient_permanent: `Veuillez garder à l'esprit que retirer l'attribution du patient est une action permanente.`,
    you_able_to_unassign: `Vous êtes sur le point de vous retirer l'attribution`,
    node_mac_address_required: `L'adresse mac du nœud est requise`,
    not_assigned: 'Non attribué',
    assign_node_to: 'Attribuer un nœud à',
    create_user: 'Créer un utilisateur',
    email_is_required: 'Adresse e-mail requise',
    created_successfully: 'Créé avec succès',
    manage_patient_data: 'GÉRER LES DONNÉES DU PATIENT',
    selected_patient: 'PATIENT SÉLECTIONNÉ',
    archive_patient: 'ARCHIVER LE PATIENT',
    archive_patient_warning: `Archiver les données du patient. Le patient n'apparaîtra plus sur le système tant qu'il n'aura pas été restauré.`,
    archive_patient_data: 'Archiver les données du patient',
    restore_patient: 'Restaurer le patient',
    restore_patient_warning: `Restaurer les données archivées afin qu'elles puissent être visualisées sur ce système.`,
    archive_date: `Date d'archivage`,
    restore_patient_data: 'Restaurer les données du patient',
    delete_account: 'SUPPRIMER LE COMPTE',
    user_accounts: `Comptes d'utilisateurs`,
    selected_site: 'Site sélectionné',
    no_site: 'Aucun site',
    drag_the_login_background_here: `Faites glisser l'arrière-plan de connexion ici`,
    drag_the_menu_background_here: `Faites glisser l'arrière-plan du menu ici`,
    patient_data_privacy: 'CONFIDENTIALITÉ DES DONNÉES DU PATIENT',
    edit_theme: 'Modifier le thème',
    drag_the_main_content_background_here: `Faites glisser l'arrière-plan du contenu principal ici`,
    opacity_desc: 'Opacité (Transparence du contenu suspendu en arrière-plan)',
    menu_bg: 'Arrière-plan du menu',
    main_content_bg: 'Arrière-plan du contenu principal',
    background: 'Arrière-plan',
    account: 'compte',
    super_admin: 'super administrateur',
    help: 'Aide',
    filter_by_user_name: `filtre par nom d'utilisateur`,
    drag_the_top_nav_background_here: `Faites glisser le haut de l'arrière-plan de navigation ici`,
    apply_theme: 'Appliquer le thème',
    apply_to_this_domain: 'Appliquer à ce domaine',
    crop_image: `Recadrer l'image`,
    enlarge: 'Agrandir',
    narrow: 'Rétrécir',
    left_rotation: 'Rotation à gauche',
    right_rotation: 'Rotation à droite',
    remove_image: `Supprimer l'image`,
    operation_area: `Zone d'opération`,
    preview_area: 'Prévisualiser la zone',
    logo_shape: 'Forme du logo',
    show_as_circle: 'Afficher en tant que cercle',
    history: 'Historique',
    status: 'États',
    download: 'Télécharger',
    export: 'Exporter',
    created_date: 'Date de création',
    next: 'Suivant',
    register: `S'inscrire`,
    back: 'Retour',
    create_an_organisation: 'Créer une organisation',
    please_enter_organisation_name: `Veuillez saisir le nom de l'organisation`,
    address: 'Adresse',
    please_enter_organisation_address: `Veuillez saisir l'adresse de l'organisation`,
    phone: 'Téléphone',
    please_enter_organisation_phone: `Veuillez saisir le téléphone de l'organisation`,
    description: 'Description',
    add_facility: 'Ajouter une installation',
    edit_facility: 'Modifier une installation',
    facility: 'Installation',
    no_room: 'Aucune chambre',
    facility_name: `Nom de l'installation`,
    add_room: 'Ajouter une chambre',
    room_already_exists: 'Une chambre existe déjà',
    home: 'accueil',
    signed_into: 'Connecté à',
    please_select_an_organisation: 'Veuillez sélectionner une organisation',
    hello: 'Bonjour',
    useful_features: 'Fonctions utiles',
    attention: 'Attention',
    quick_actions: 'Actions rapides',
    no_patient_warning: `Il n'y a pas de patients à surveiller. Ajoutez des patients maintenant pour commencer.`,
    add_patient_quick_action_desc: 'Ajouter un patient à surveiller',
    welcome_to_the_group_dashboard:
      'Bienvenue sur le tableau de bord du groupe',
    show_me_more: 'Télécharger plus',
    add: 'ajouter',
    welcome_to_patient_management: 'Bienvenue dans la Gestion des patients',
    update_patient: 'Mettre à jour le patient',
    update_patient_quick_action_desc: `Mettre à jour les détails du patient`,
    change_patient_products: `Modifier les produits du patient`,
    change_patient_products_quick_action_desc:
      'Changer le produit utilisé par le patient',
    reassign_pod_to_patient: 'Réattribuer le module au patient',
    reassign_pod_quick_action_desc: `Changer le dispositif du patient`,
    monitor_patient_with_a_node: 'Assigner un nœud au patient',
    monitor_patient_with_a_node_quick_action_desc: `Examiner le nœud d'un patient`,
    welcome_to_the_administration_section: `Bienvenue à la Section d'administration`,
    invite_user: 'Ajouter un utilisateur',
    invite_user_quick_action_desc: 'Inviter un utilisateur au système',
    remove_or_archive_patient: 'Supprimer/archiver le patient',
    remove_or_archive_patient_quick_action_desc:
      'Supprimer un patient du tableau de bord',
    profile: 'Profil',
    not_monitored: 'non surveillé',
    rounds: 'Séries',
    //translate permissions list
    'Super Admin': 'Super Admin',
    Algorithms: 'Algorithmes',
    Customisation: 'Personnalisation',
    Account: 'Compte',
    'Roles & Permissions': 'Rôles et autorisations',
    'Network Map': 'Plan de réseau',
    'Network Utilisation': 'Utilisation du réseau',
    'Buildings & Rooms': 'Installations et chambres',
    Manufacturers: 'Fabricants',
    Settings: 'Paramètres',
    Profile: 'Profil',
    Devices: 'Appareils',
    Nodes: 'Nœuds',
    'Pods Location': 'Emplacement des dispositifs',
    'Share Code': 'Code de partage',
    Users: 'Utilisateurs',
    'User Accounts': `Comptes d'utilisateurs`,
    'Invite User': 'Ajouter un utilisateur',
    Patients: 'Patients',
    'Monitor Patient': 'Surveiller le patient',
    'Patient Data Privacy': 'Confidentialité des données du patient',
    Archive: 'Archiver',
    Restore: 'Restaurer',
    'Patients Module': 'Module des patients',
    Export: 'Exporter',
    History: 'Historique',
    Report: 'Rapport',
    Monitor: 'Surveiller',
    //translate permissions list
    time_zone: 'Fuseau horaire',
    please_select_time_zone: 'Veuillez sélectionner un fuseau horaire',
    add_facility_and_room: 'AJOUTER UNE INSTALLATION ET UNE CHAMBRE',
    filter_by_facility_name: `filtrer par nom d'installation`,
    floor: 'Étage',
    please_enter_facility_name: `Veuillez saisir le nom de l'installation`,
    please_enter_floor_name: `Veuillez saisir le nom de l'étage`,
    please_enter_room_number: 'Veuillez saisir le numéro de chambre',
    facility_name_already_exists: `Le nom de l'installation existe déjà`,
    floor_name_should_be_unique: `Le nom de l'étage doit être unique`,
    room_number_should_be_unique: 'Le numéro de chambre doit être unique',
    add_manufacturer: 'Ajouter le fabricant',
    filter_by_manufacturer_code_or_name: 'filtrer par code fabricant ou nom',
    enabled: 'Activé',
    delete_manufacturer_warning: 'La suppression du fabricant est permanente. ',
    please_enter_role_name: 'Veuillez saisir le nom du rôle',
    please_choose_one_as_the_current_organization:
      'Veuillez en choisir un comme organisation actuelle',
    display_name: 'Nom visible',
    assign_roles: 'Attribuer des rôles',
    remove: 'Supprimer',
    please_assign_a_role_to_the_user: `Veuillez attribuer un rôle à l'utilisateur`,
    send_invitation: `envoyer l'invitation`,
    invitation_email_sent: `E-mail d'invitation envoyé.`,
    facility_and_Floor_and_Room: 'Installations, étage et chambre',
    export_patient: 'patient exporté',
    export_patient_history_data: `Exporter les données de l'historique du patient`,
    export_patient_data: 'Exporter les données du patient',
    export_report_success_text: `Exportation des données du patient en cours. Vous serez averti par e-mail dès qu'il sera disponible. Vérifiez la progression dans l'onglet Fichiers. `,
    select_patients: 'Sélectionner les patients',
    export_in_progress: 'Exportation en cours',
    continue: 'continuer',
    please_enter_patient_name: `Veuillez saisir le nom du patient`,
    please_enter_patient_alias: `Veuillez saisir l'alias du patient`,
    facility_and_room: 'Installation et chambre',
    create_new: 'Créer Nouveau',
    add_facility_and_floor_and_room:
      'Ajouter une installation, un étage et une chambre',
    select_facility_floor_room:
      'Sélectionnez une installation, un étage et une chambre',
    choose_one: 'Choisir une',
    enter_manually: 'Saisir manuellement',
    pod_serial_number_format_incorrect:
      'Le format du numéro de série du dispositif saisi est incorrect.',
    add_a_manufacturer_to_continue: 'Ajouter un fabricant pour continuer',
    please_enter_subscription_code: `Veuillez saisir le code d'abonnement`,
    added_successfully: 'Ajouté avec succès',
    select_a_patient: 'Sélectionner un patient',
    assign_products: 'Attribuer des produits',
    assign_pod: 'Attribuer le dispositif',
    assign_node: 'Attribuer un nœud',
    we_have_created_a_default_facility:
      'nous avons créé une installation, un étage et une chambre par défaut pour votre organisation',
    if_you_want_edit_this_facility: `Si vous souhaitez modifier les informations de cette installation, appuyez sur`,
    or_you_can: 'Ou bien vous pouvez',
    already_registered: 'Déjà inscrit',
    sign_up: `S'inscrire`,
    create_account: 'Créer un compte',
    pod_and_diaper: 'Dispositif et couche',
    pod_and_diaper_content: ` <p class="underline">Suivez ces étapes pour connecter le dispositif à la couche :</p>
          <ul>
            <li>
                        Alignez les trois bandes de la couche Smart avec les trois broches dorées du dispositif Smart
            </li>
            <li>Attachez le dispositif à l'<span class="underline">avant</span> de la couche Smart</li>
            <li>
                        Voyant vert clignotant rapidement pendant 3 secondes, puis fixe pendant 1 seconde = bonne connexion
            </li>
            <li>
            Pas de voyant vert clignotant après 20 secondes = pas de connexion Déclipser et reclipser le dispositif Smart 
            </li>
            <li>Si aucun voyant ne clignote alors que la connexion est correcte, la batterie est épuisée</li>
          </ul>`,
    home_landing_slide1_title: 'Bienvenue sur le portail de santé',
    home_landing_slide1_content: `
      <p>Le portail de santé vous permet de surveiller la continence et le bien-être de votre patient.</p>
      <p>Surveillez les groupes de patients afin de prioriser les actions et fournir des soins centrés sur l'individu.</p>`,
    home_landing_slide2_title: 'Technologie couche Smart',
    home_landing_slide2_content: `
      <p>Lorsqu'un dispositif Smart pod est attaché à une couche Smart, il transmet des données via un réseau permettant au soignant de surveiller le patient via le portail de santé.</p>
      <p>Une fois votre patient attribué dans le système, vous saurez d'un coup d'œil quand changer sa couche et vous pourrez consulter les données historiques. Vous pouvez aussi facilement fixer des objectifs et être informé du moment où il faut changer la couche, de la position de votre patient, de la surveillance du débit de liquide, de la température ambiante et des chutes potentielles.</p>`,
    home_landing_slide4_title: 'Ajouter le premier patient',
    home_landing_slide4_content: `
      <p>Pour commencer, ajoutez un patient en utilisant le bouton Action rapide et suivez les instructions.</p>
      <p>Le système vous aidera tout au long du processus de configuration du patient.</p>`,
    home_landing_slide5_title: 'Actions rapides',
    home_landing_slide5_content: `
      <p>Ceux-ci vous permettent d'accéder à des actions fréquentes telles que l'ajout d'un patient.</p>
      <p>Un assistant vous guidera à travers toutes les étapes nécessaires. </p>`,
    dashboard_landing_slide1_title:
      'Bienvenue sur le tableau de bord du groupe',
    dashboard_landing_slide1_content: `
      <p>Surveillez tous vos patients sur le tableau de bord et sachez quand vos patients ont besoin d'attention.</p>
      <p>Vous pouvez réduire votre charge de travail en suivant les invites visuelles du système.</p>`,
    dashboard_landing_slide2_title:
      'Bienvenue sur le tableau de bord du groupe',
    dashboard_landing_slide2_content: `<ul>
      <li>Les icônes indiquent l'état du patient</li>
      <li>Il y a deux sections sur le tableau de bord, une section <span class="underline">Action requise</span> et une <span class="underline">section</span> Suivi</li>
      <li>Afin de réduire la charge de travail et d'améliorer les soins aux patients, accordez une priorité élevée aux icônes <span class="underline">« Action requise »</span></li>
    </ul>`,
    dashboard_landing_slide3_title: 'Les états de la couche',
    dashboard_landing_slide3_content: `
      <p>L'état de la couche et le « moment de la changer » sont représentés par un système de feux de signalisation :</p>
      <ul>
        <li><span class="red-text"><span class="underline">Rouge</span> = changer la protection,</span> c'est-à-dire la couche mouillée qui risque de fuir</li>
        <li><span class="yellow-text"><span class="underline">Jaune</span> = se préparer à changer de couche,</span> c'est-à-dire que la couche atteint sa capacité</li>
        <li><span class="green-text"><span class="underline">Vert </span> = pas d'action</span> c'est-à-dire couche sèche</li>
      </ul>`,
    dashboard_landing_slide4_title: 'Autres états',
    dashboard_landing_slide4_content: `
      <p>Pour assurer la continuité des soins, occupez-vous de toutes les actions affichées sur le tableau de bord :</p>
      <ul>
        <li>Le symbole « Connexion perdue » indique que la connexion Bluetooth a été perdue et qu'il peut y avoir une perte de données.</li>
        <li>Le symbole « Changer de position » indique qu'il est temps de changer la position du patient.</li>
      </ul>`,
    dashboard_landing_slide5_title: 'Optimiser',
    dashboard_landing_slide5_content: `<p>Examinez les notifications du tableau de bord du groupe pour optimiser vos soins quotidiens aux patients.</p>`,
    dashboard_landing_slide6_title: 'Filtres de zone',
    dashboard_landing_slide6_content: `
      <p>Le filtre de zone est une fonction facultative qui vous permet d'afficher une zone sélectionnée sur votre tableau de bord de l'installation. Utilisez les filtres de zone avec prudence, car ils masquent les patients existants et n'affichent que les sélections de filtres.</p>
      <p>Pour choisir le nouveau filtre de zone : </p>
      <ol>
        <li>Sélectionner une zone dans la liste déroulante</li>
        <li>Appuyer sur « Nouvelle zone »</li>
        <li>Saisir le « Nom du filtre de zone »</li>
        <li>Sélectionner le bâtiment</li>
        <li>Cocher les numéros de zone, d'étage et de chambre</li>
        <li>Vérifier votre sélection de filtre dans la zone de résumé de filtre</li>
        <li>Appuyer pour enregistrer ce filtre de zone</li>
        <li>Sélectionner le filtre de zone ou « Gérer les zones » dans la liste déroulante</li>
      </ol>
    `,
    home_landing_slide3_title: 'Dispositif et couche',
    home_landing_slide3_content: `
    <ul>
      <li>Connecter le dispositif à la couche</li>
      <li>Regarder les voyants LED verts sur le dispositif</li>
      <li>Recevoir les mises à jour des états des patients</li>
    </ul>`,
    patient_landing_slide1_title: 'Tableau de bord individuel',
    patient_landing_slide1_content: `
      <p>En sélectionnant un patient individuel, un nouveau tableau de bord affiche les états de toutes les fonctions actuellement surveillées, y compris le dispositif Smart et la couche en cours d'utilisation.</p>
      <p>Choisissez un autre patient à afficher dans le menu déroulant.</p>`,
    patient_landing_slide2_title: `Bienvenue dans la section Patient`,
    patient_landing_slide2_content: `
      <p>Le tableau de bord individuel indique l'état actuel du patient.</p>
      <p>La section Graphiques décrit les tendances en matière de santé.</p>
      <p>Des objectifs spécifiques peuvent être définis dans la section Objectifs et les notifications reçues.</p>`,
    patient_landing_slide3_title:
      'Accéder au tableau de bord individuel, aux graphiques et aux objectifs',
    patient_landing_slide3_content: `<p>Sur le côté gauche du tableau de bord, vous pouvez accéder à la section Patient, Graphiques et Objectifs.</p>`,
    patient_landing_slide4_title: 'Tableau de bord patient / individuel',
    patient_landing_slide4_content: `
      <ul>
        <li>Chaque patient dispose de son propre tableau de bord individuel</li>
        <li>Approfondissez l'état individuel de votre patient</li>
        <li>Basculer entre les patients en sélectionnant dans la flèche déroulante</li>
      </ul>`,
    patient_landing_slide5_title: 'Graphiques',
    patient_landing_slide5_content: `
      <p>Différents graphiques vous permettent de visualiser et d'interpréter les données, notamment :</p>
      <ul>
        <li>Graphique représentant les mictions</li>
        <li>Profil de remplissage de la protection</li>
        <li>Graphique de position.</li>
      </ul>
      <p>Vous pouvez les imprimer et les partager afin de revoir et d'ajuster les soins de votre patient.</p>`,
    patient_landing_slide6_title: 'Objectifs',
    patient_landing_slide6_content: `
      <p>Pour améliorer encore les soins de votre patient, des objectifs spécifiques peuvent être fixés. Notamment :</p>
      <ul>
        <li>Position du corps</li>
        <li>Soins de la peau</li>
        <li>Profil de remplissage de la protection</li>
        <li>Température</li>
        <li>Chutes.</li>
      </ul>`,
    common_help_content: `
      <ul>
        <li>Choisissez le patient à afficher en utilisant simplement le menu déroulant.</li>
      </ul>`,
    chart_common_slide_content: `
      <ul>
        <li>En sélectionnant la plage de dates, un maximum de 7 jours peut être affiché.</li>
      </ul>`,
    voiding_chart_slide1_content: `
      <ul>
        <li>Le graphique représentant les mictions fournira une vue d'ensemble de l'historique des mictions de vos patients.</li>
        <li>Les données en temps réel sont affichées sur le graphique représentant les mictions lors de l'utilisation du système Smartz<sup> ®</sup>.</li>
        <li>Ce graphique vous permet de basculer entre la visualisation du cycle de la protection et l'aperçu des événements de mictions.</li>
      </ul>`,
    voiding_chart_slide4_content: `
      <ul>
        <li>Les icônes peuvent être filtrées par sélection.</li>
        <li>La légende sous le graphique représentant les mictions affiche les icônes figurant sur le graphique.</li>
        <li>Appuyez sur « filtres de graphique » pour sélectionner ou désélectionner les icônes que vous souhaitez afficher.</li>
      </ul>`,
    voiding_chart_slide5_content: `
      <p>En visualisant ce graphique, vous êtes en mesure de/d' :</p>
      <ul>
        <li>identifier les moments potentiels où le patient pourrait bénéficier d'une toilette réussie</li>
        <li>si la couche a été changée dans un délai acceptable</li>
        <li>le nombre de changements de protection sur la période</li>
        <li>partagez et imprimez votre graphique.</li>
      </ul>`,
    smartz_events_slide1_content: `
      <ul>
        <li>Le graphique des événements affiche tous les événements pour les statuts couche, dispositif, objectif et réseau.</li>
      </ul>`,
    pad_fill_profile_chart_slide1_content: `
      <ul>
        <li>Le « Profil quotidien total » affiche la quantité totale de mictions absorbées dans la protection sur une période de 24 h.</li>
        <li>Le débit quotidien dans la couche est indiqué au-dessus de chaque goutte.</li>
      </ul>`,
    pad_fill_profile_chart_slide4_content: `
      <ul>
        <li>L'icône à droite indique le volume de sortie 'Moyen' sur la période de jours sélectionnée.</li>
        <li>Faites basculer pour voir les profils « Jour » et « Nuit » séparément.</li>
        <li>Le graphique indique si un objectif de profil de remplissage de tampon a été défini ou déclenché.</li>
        <li>Choisissez de définir l'objectif si nécessaire.</li>
      </ul>`,
    pad_fill_profile_chart_slide5_content: `
      <ul>
        <li>Le profil journalier total indique la quantité totale de mictions absorbées dans la couche pendant une période de 24 heures.</li>
        <li>Si le patient enregistre une réduction du débit urinaire, cela peut indiquer qu'il faut augmenter l'hydratation.</li>
        <li>Partagez et imprimez votre graphique.</li>
      </ul>`,
    body_position_chart_slide1_content: `
      <ul>
        <li>Le graphique affiche la durée du temps passé dans une position du corps sur un nombre de jours sélectionné.</li>
        <li>Pour plus de détails, passez le curseur sur le graphique.</li>
      </ul>`,
    body_position_chart_slide4_content: `
      <ul>
        <li>Appuyez sur « filtres de graphique » pour sélectionner ou désélectionner les positions que vous souhaitez afficher.</li>
        <li>Le graphique met en évidence si un objectif de position du corps a été défini.</li>
        <li>Appuyez pour définir l'objectif.</li>
      </ul>`,
    body_position_chart_slide5_content: `
      <ul>
        <li>Si vous avez un patient qui est sujet à des lésions cutanées / des escarres, en fixant l'objectif, vous serez informé du moment où il faut changer la position du patient.</li>
        <li>Lorsque « imprimer » est sélectionné, les positions et les périodes sont répertoriées plus en détail. </li>
      </ul>`,
    goal_common_slide_content: `
      <ul>
        <li>Vérifiez la section avec l'icône de l'ampoule pour plus de détails.</li>
      </ul>`,
    body_position_goal_help_title: 'Objectif de la position du corps',
    body_position_goal_slide1_content: `
      <ul>
        <li>En fixant l'objectif, le soignant est informé du moment où il doit changer la position du patient.</li>
        <li>Utilisez cet objectif si vous avez un patient qui est enclin à des lésions cutanées / des escarres.</li>
        <li>Réduire le temps passé dans une même position pourrait contribuer à atténuer la formation d'escarres.</li>
      </ul>`,
    body_position_goal_slide2_content: `
      <ul>
        <li>Choisissez le patient à afficher en utilisant simplement le menu déroulant.</li>
        <li>Déplacez le curseur pour choisir la durée maximale pendant laquelle vous souhaitez que votre patient reste dans la même position, que ce soit le jour et/ou la nuit.</li>
        <li>Appuyez pour enregistrer l'objectif.</li>
      </ul>`,
    body_position_goal_slide3_content: `
      <ul>
        <li>Vous avez maintenant sélectionné la durée maximale pendant laquelle votre patient peut rester dans une position. Vous serez informé dans la section « Action requise » quand vous devrez la changer.</li>
      </ul>`,
    skin_management_goal_help_title: 'Objectif de gestion de la peau',
    skin_management_goal_slide1_content: `
      <ul>
        <li>Changer la couche plus régulièrement pourrait aider à garder la peau du patient sèche et à réduire les irritations cutanées.</li>
      </ul>`,
    skin_management_goal_slide2_content: `
      <ul>
        <li>Choisissez le patient à afficher en utilisant simplement le menu déroulant.</li>
        <li>Déplacez le curseur pour sélectionner la durée maximale pendant laquelle vous souhaitez que votre patient porte une couche.</li>
        <li>Appuyez pour enregistrer l'objectif.</li>
      </ul>`,
    skin_management_goal_slide3_content: `
      <ul>
        <li>Vous recevrez maintenant une notification dans la section « Action requise » pour changer la couche du patient.</li>
      </ul>`,
    pod_temperature_goal_help_title: 'Température environnante du dispositif',
    pod_temperature_goal_slide1_content: `
      <ul>
        <li>Cet objectif vous permet de définir la température minimale / maximale de la nacelle environnante.</li>
        <li>Définissez cet objectif si vous êtes préoccupé par la fluctuation de la température de votre patient.</li>
      </ul>`,
    pod_temperature_goal_slide2_content: `
      <ul>
        <li>Choisissez le patient à afficher en utilisant simplement le menu déroulant.</li>
        <li>Pour être informé de tout changement de température autour du dispositif, déplacez le curseur pour choisir les températures minimale et maximale.</li>
        <li>Appuyez pour enregistrer l'objectif.</li>
      </ul>`,
    pod_temperature_goal_slide3_content: `
      <ul>
        <li>Vous serez maintenant averti dans la section « Action requise » lorsque la température environnante du dispositif est en dehors de la plage définie.</li>
      </ul>`,
    pad_fill_profile_goal_help_title:
      'Objectif du profil de remplissage de la protection',
    pad_fill_profile_goal_slide1_content: `
      <ul>
        <li>Cet objectif vous permet de définir le volume minimal/maximal de mictions absorbées dans la couche si vous pensez que votre patient a un faible débit urinaire.</li>
      </ul>`,
    pad_fill_profile_goal_slide2_content: `
      <ul>
        <li>Choisissez le patient à afficher en utilisant simplement le menu déroulant.</li>
        <li>Déplacez le curseur pour sélectionner le volume préféré pour le jour et / ou la nuit.</li>
        <li>Appuyez pour enregistrer l'objectif.</li>
      </ul>`,
    pad_fill_profile_goal_slide3_content: `
      <ul>
        <li>Vous serez maintenant averti dans la section « Action requise » lorsque le volume de mictions de votre patient dans la couche est en dehors de la plage définie.</li>
      </ul>`,
    fall_detection_goal_help_title: 'Objectif de détection des chutes',
    fall_detection_goal_slide1_content: `
      <ul>
        <li>Cet objectif vous avertira si votre patient est tombé.</li>
      </ul>`,
    fall_detection_goal_slide2_content: `
      <ul>
        <li>Choisissez le patient à afficher en utilisant simplement le menu déroulant.</li>
        <li>Déplacez le curseur sur la position ON pour activer l'objectif.</li>
        <li>Par défaut, le « Temps en position » est activé. </li>
        <li>Appuyez pour enregistrer l'objectif.</li>
      </ul>`,
    fall_detection_goal_slide3_content: `
      <ul>
        <li>Si une chute s'est produite, une icône clignotante s'affiche dans la section « Action requise ».</li>
        <li>Mettre en sourdine la chute dans le « Tableau de bord individuel » supprimera l'icône du tableau de bord principal.</li>
      </ul>`,
    voiding_chart_help_dialog_title:
      'Utilisation du graphique représentant les mictions',
    pad_fill_profile_chart_help_dialog_title:
      'Utilisation du profil de remplissage de la protection',
    position_chart_help_dialog_title:
      'Utilisation du tableau de position du corps',
    pad_fill_profile_goal_help_dialog_title: `Configuration de l'objectif de profil de remplissage de la protection`,
    skin_care_goal_help_dialog_title: `Configuration de l'objectif de gestion des soins de la peau`,
    position_goal_help_dialog_title: `Configuration de l'objectif de position du corps`,
    temperature_goal_help_dialog_title: `Configuration de l'objectif de la température environnante de la protection`,
    fall_detection_goal_help_dialog_title: `Configuration de l'objectif de détection des chutes`,
    invite_user_quick_action_desc_for_home_landing:
      'Inviter un prestataire de soins à rejoindre cette organisation',
    archived_successfully: 'Archivé avec succès',
    verification_passed: 'Vérification réussie',
    verification_failed: 'Échec de la vérification',
    verify_error_msg_801: `Votre invitation a expiré ou n'est plus valide. Pour demander une autre invitation, contactez l'administrateur de l'organisation.`,
    verify_error_msg_802: `Votre invitation n'est pas valide pour cet utilisateur. Si vous étiez connecté en tant qu'utilisateur différent avant d'accepter cette invitation. Veuillez vous déconnecter et réessayer.`,
    verify_error_msg_803: 'Utilisateur non trouvé.',
    verify_error_msg_804: `Code d'invitation non trouvé.`,
    verify_error_msg_805: `Vous êtes déjà membre de l'organisation à laquelle vous souhaitez adhérer.`,
    verify_success_msg: 'Bienvenue à la nouvelle organisation.',
    verify_error_msg_not_sign_in: `Veuillez vous connecter pour rejoindre l'organisation. <br/> Si vous n'avez pas de compte, veuillez d'abord vous inscrire.`,
    verify_error_msg_620: `Le code n'est pas valide ou a expiré`,
    verify_error_msg_622: `Impossible de rejoindre l'organisation. Le code d'invitation n'est pas valide pour cette adresse e-mail.`,
    failed_to_get_chart_data: `Impossible d'envoyer les données du graphique.`,
    filter: 'Filtrer',
    please_select_facility_first: `Veuillez d'abord sélectionner l'installation`,
    areas: 'Zone(s)',
    floors: 'Étage(s)',
    new_area: 'Nouvelle zone',
    manage_areas: 'Gérer les zones',
    show_all_facilities: 'Afficher toutes les installations',
    show_all_areas: 'Afficher toutes les zones',
    new_area_filter: 'Nouveau filtre de zone',
    area_filter_name: 'Nom du filtre de zone',
    area: 'Zone',
    please_enter_area_filter_name: 'Veuillez saisir le nom du filtre de zone',
    please_select_facility: `Veuillez sélectionner l'installation`,
    please_select_floor_and_room: `Veuillez sélectionner l'étage et la chambre`,
    please_select_organisation: 'Veuillez sélectionner une organisation',
    filter_summary: 'Résumé du filtre',
    show_patients_from: 'Afficher les patients de',
    in: 'à',
    and: 'et',
    belonging_to: 'appartenant à',
    select_an_area: 'Sélectionnez une zone',
    manage_area: 'Gérer la zone',
    please_select_area_filter: 'Veuillez sélectionner un filtre de zone',
    delete_area: 'Supprimer la zone',
    keep_in_mind_delete_area: `La suppression d'une zone sera permanente. `,
    facility_information: `Informations sur l'installation`,
    floor_information: 'Informations sur l’étage',
    room_information: 'Information sur la chambre',
    number_of_floors: `Nombre d'étages`,
    please_enter_number_of_floors: `Veuillez saisir le nombre d'étages`,
    number_of_rooms: 'Nombre de chambres',
    please_enter_number_of_rooms: 'Veuillez saisir le nombre de chambres',
    add_floor: 'Ajouter un étage',
    remove_floor: 'Supprimer un étage',
    remove_room: 'Supprimer une chambre',
    select_area_warning: `La zone et l'étage ne peuvent pas être sélectionnés en même temps. <br/>Sélectionnez-en une seule.`,
    manage_area_filter: 'Gérer le filtre de zone',
    no_area: 'Pas de zone',
    there_are_no_patient_to_manage: `Il n'y a pas de Patients à gérer.`,
    default_themes: 'Thèmes par défaut',
    custom_themes: 'Champs personnalisés',
    background_color: 'Couleur d’arrière-plan',
    top_navigation_background_color: `Couleur d'arrière-plan de la navigation supérieure`,
    top_nav_text_color: 'Couleur du texte de navigation supérieure',
    top_nav_active_text_color:
      'Couleur du texte actif de navigation supérieure',
    sidebar_background_color: `Couleur d'arrière-plan de la barre latérale`,
    sidebar_active_block_background_color: `Couleur d'arrière-plan du bloc actif de la barre latérale`,
    sidebar_text_color: 'Couleur du texte de la barre latérale',
    sidbar_active_block_text_color:
      'Couleur du texte du bloc actif de la barre latérale',
    card_title_background_color: 'Couleur de fond du titre de la carte',
    card_title_text_color: 'Couleur du texte du titre de la carte',
    card_body_background_color: `Couleur de l'arrière-plan principal de la carte`,
    card_button_color: 'Couleur du bouton de la carte',
    room_number: 'Numéro de la chambre',
    verify_invitation: `VÉRIFIER L'INVITATION`,
    well_done: 'Bien joué !',
    you_have_updated_the_patient: `Vous avez mis à jour les détails du patient.`,
    you_have_created_the_patient:
      'Vous avez ajouté un patient qui peut être consulté sur le tableau de bord du groupe.',
    tell_me_more: 'En savoir plus',
    registered_pods: 'Dispositifs enregistrés',
    registered_nodes: 'Nœuds enregistrés',
    select: 'Sélectionner',
    start: 'Commencer',
    end: 'Fin',
    floor_name: `Nom de l'étage`,
    sign_in_failed: 'Échec de la connexion',
    skin_care_goal_title: `Durée d'utilisation de la protection`,
    'Event Chart': 'Tableau des événements Smartz',
    account_information: 'Information du compte',
    given_name: 'Prénom',
    surname: 'Nom de famille',
    please_enter_pod_serial_number:
      'Veuillez saisir le numéro de série de la protection',
    manufacturer_subscription_code: `Code d'abonnement du fabricant`,
    remove_node_mac_address: `Supprimer l'adresse mac du nœud`,
    link_a_node_mac_address: 'Lier une adresse Mac de nœud',
    export_data: 'Exporter les données',
    available_files: 'Fichiers disponibles',
    export_patient_data_desc:
      'Cliquez sur le bouton suivant pour exporter les données historiques de',
    dry_diaper: 'Couche sèche',
    wet_diaper: 'Couche humide',
    change_diaper: 'Changer la couche',
    external_humidity: 'Humidité externe',
    smartz_events: ' Événements Smartz<sup>®</sup>',
    smartz_events_chart_email_content: `Le graphique d'événements envoyé par e-mail est prêt à être examiné.`,
    reposition: 'Repositionner',
    fall: 'chute',
    cycle: 'Cycle',
    pad_cycle: 'cycle de la protection',
    off_body: 'hors du corps',
    pad_status_legend: 'État de la protection',
    analysing_diaper_legend: 'Analyse de la couche',
    dry_wet_change_diaper: 'couche sèche/humide/à changer',
    pod_status: 'État du dispositif',
    goal_status: `État de l'objectif`,
    diaper_removed_legend: 'Couche retirée',
    time_to_change_legend: 'temps-de-changer',
    out_of_range_legend: 'hors-de-portée',
    diaper_not_selected: 'Couche non sélectionnée',
    duration: 'Durée',
    small_void: 'Petite miction',
    medium_void: 'Miction moyenne',
    large_void: 'Grande miction',
    view_mode: `Mode d'affichage`,
    voids_only: 'mictions uniquement',
    void_event_size: `taille d'événement de miction`,
    pad_start: 'Début de la protection',
    pad_end: 'Fin de la protection',
    exceed_goal_time: 'Dépasser le temps cible',
    reclip: 'reclipser',
    unstable_readings: 'Lectures instables',
    not_selected: 'Non séléctionné',
    analysing: `En cours d'analyse`,
    create_organisation: 'Créer une organisation',
    all_times_are_in: 'Les horaires sont en',
    failed_to_get_goal_settings: `Impossible d'obtenir les paramètres de l'objectif`,
    next_steps: 'Prochaines étapes',
    video: 'Vidéo',
    monitor_warning: `La surveillance n'est pas disponible car il n'y a pas de dispositif Smartz<sup>®</sup> attribué à`,
    find_further_information: 'En savoir plus',
    here: 'ici',
    savePatientPodErrMsg: `Le numéro de série du dispositif fourni n'existe pas dans cette organisation.`,
    savePatientNodeErrMsg: `L'adresse mac de nœud fournie n'existe pas dans cette organisation.`,
    already_registered_desc: `Veuillez vous connecter en utilisant le nom d'utilisateur et le mot de passe avec lesquels vous vous êtes inscrit initialement.`,
    create_account_desc: `Veuillez fournir un nom d'utilisateur et un mot de passe pour créer un compte d'utilisateur et afin d'accéder au site.`,
    signing_in: 'Connexion',
    signing_out: 'Déconnexion',
    welcome: 'Bienvenue',
    top: 'Haut',
    facility_or_building: 'Installation / Bâtiment',
    keep_at_least_one_facility: 'Conserver au moins une installation',
    keep_at_least_one_floor: 'Conserver au moins un étage',
    keep_at_least_one_room: 'Conserver au moins une chambre',
    rename: 'Renommer',
    domain_name: 'Nom de domaine',
    subscription_code: `Code d'abonnement`,
    events: 'Événements',
    no_pods_text: `Il n'y a pas de dispositifs enregistrées dans cette organisation.`,
    no_nodes_text: `Il n'y a pas de nœuds enregistrés dans cette organisation.`,
    confirm_deletion: 'Confirmer la suppression.',
    confirm_archive: `Confirmer l'archive.`,
    account_deletion: 'Suppression de compte',
    delete_account_warning:
      'La suppression du compte utilisateur et des données personnelles est permanente.',
    deletion: 'Suppression',
    restoring_patient: 'Restauration du patient',
    font_family: 'Famille de la police',
    font_size: 'Taille de la police',
    font_color: 'Couleur de la police',
    main_title: 'Titre principal',
    title: 'Titre',
    small_title: 'Petit titre',
    body_text: 'Corps du texte',
    body_text_small: 'Corps du texte (petit)',
    supplementary_text: 'Texte supplémentaire',
    primary_text: 'Texte principal',
    regular_text: 'Texte régulier',
    secondary_text: 'Texte secondaire',
    placeholder_text: 'Texte d’espace réservé',
    top_nav_background: 'Arrière-plan de la barre du haut',
    edit_facility_and_floor_and_room: `Modifier l'installation, l'étage et la chambre`,
    please_select_buildings: 'Veuillez sélectionner des bâtiments',
    please_select_floors: 'Veuillez sélectionner des étages',
    please_select_rooms: 'Veuillez sélectionner des chambres',
    facility_setup: `Configuration de l'installation`,
    view_a_patient_by_selecting_from_drop_down_menu:
      'Voir le patient en sélectionnant dans le menu déroulant.',
    monitoring: 'Suivi',
    silencing: 'Silence',
    fall_detection: 'Détection des chutes',
    pod: 'Pod',
    diaper: 'Couches',
    time_in_diaper: 'Temps de couches',
    setup_area_filter_desc:
      'Suivez ces étapes pour configurer un nouveau filtre de zone.',
    max_time_in_pad: 'Temps maximum dans le pad',
    max_time_in_pos: 'Temps de mise en place maximal',
    change_in: 'Remplacer dans les',
    not_monitoring: 'Non surveillé',
    exceed_allowed_time: 'Dépassement du délai autorisé',
    Pseudonymized: 'Pseudonyme',
    Anonymized: 'Anonyme',
    pseudonymized_permission_warning: `Vous ne pouvez pas sélectionner à la fois les permissions de pseudonyme du patient et les permissions d'édition du patient. Veuillez en sélectionner un.`,
    anonymized_permission_warning: `Vous ne pouvez pas sélectionner à la fois les permissions d'anonymat du patient et les permissions d'édition du patient. Veuillez en sélectionner un.`,
    please_select_one_product:
      'Veuillez sélectionner un produit de jour ou un produit de nuit',
    none: 'Pas un seul',
    invitation: 'Invitation',
    has_invited: 'a invité',
    to_join: 'joindre',
    invitation_desc:
      'Si vous avez déjà un compte avec cette adresse e-mail, veuillez vous connecter pour vous inscrire.',
    if_not_please: `Si non, s'il vous plaît`,
    accept: 'accepter',
    decline: 'déclin',
    acceptable_temperature_range: 'Plage de température acceptable',
    temperature_alert_off: `L'alerte de température est désactivée`,
    temperature_alert_on: `L'alerte de température est réglée pour s'activer si la température est`,
    below: 'Ci - dessous',
    above: 'Au - dessus',
    partial_body_repositioning: 'Repositionnement partiel du corps',
    minimum_angle_change: `changement d'angle minimal`,
    degrees: 'degrés',
    goal_time_exceed: 'Objectif dépassé',
    allowed_time_exceed: 'Dépassement du temps autorisé',
    safe_time_exceed: 'Temps de sécurité dépassé',
    brief_not_used: 'Slip non utilisé',
    monitor_unstable_readings: 'Surveiller les lectures instables',
    leakage: 'Fuite',
    new_battery: 'Nouvelle batterie',
    exceed_safe_time_in_pad: 'Dépasser le temps de sécurité dans le pad',
    predicted_change_time: 'Temps de changement prévu',
    total_time: 'temps total',
    exceed_safe_time: 'Dépasser le temps de sécurité',
    consider_using_smartz_product: `envisager d'utiliser le produit smartz`,
    non_smartz_product_in_use: `Produit non smartz en cours d'utilisation`,
    product_not_selected: 'produit non sélectionné',
    assign_smartz_product_to_patient: 'attribuer le produit smartz au patient',
    wait_a_moment: 'attendez un moment...',
    find_patient: 'trouver un patient'
  },
  country: 'French',
  language: 'Français',
  abb_name: 'fr'
}
